import { getTextCss } from '@taxbit-private/cosmic'
import { Command } from 'cmdk'
import styled from 'styled-components'

import { KCommandItem } from './KCommandItem'
import { MenuCommandGroup } from '../cmdkTypes'

export const CommandGroupMenu = ({ name, commands }: MenuCommandGroup) => (
  <Group key={`command-menu-group-${name}`} heading={name}>
    {commands.map((command) => (
      <KCommandItem key={command.label} {...command} />
    ))}
    <Separator />
  </Group>
)

export const Group = styled(Command.Group)(
  ({ theme }) => `
  padding: ${theme.spacing.s} ${theme.spacing.none};

  [cmdk-group-heading] {
    width: 100%;
    ${getTextCss(theme)['h6-uppercase']};
    color: ${theme.color.textSecondary};
    padding: ${theme.spacing.xs} ${theme.spacing.m};
    background-color: ${theme.color.white};
    position: sticky;
    top: 0;
  }
`
)

export const Separator = styled(Command.Separator)(
  ({ theme }) => `
  margin: ${theme.spacing.none};
  background-color: ${theme.color.border};
  height: ${theme.borderWidth.s};
`
)
